import React, { useRef, useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import _ from 'lodash';
import { ReactSVG } from 'react-svg';
import { generateImageLink } from '../../utils/design.utils';
// import styled from 'styled-components';
import './VLine.css';

const VLine = props => {
  const dispatch = useDispatch();
  const pageWidth = useSelector(state => state.design.width);
  const entity = useSelector(state => state.design.entitiesState[props.entityId]);
  const authToken = useSelector(state => state.authentication.user.authToken);
  const { activePageRef } = useContext(DesignContext);
  const currentPage = useSelector(state => state.design.pages[activePageRef.current]);
  const [template, setTemplate] = useState(0);
  const [lineSize, setLineSize] = useState({
    width: parseInt(_.get(entity, 'style.master.width', pageWidth * 0.5)),
    height: 50,
  });

  const target = useRef(null);
  const svgLineRef = useRef(null);
  let lineConfig = { ...entity.data };
  let src = generateImageLink(entity.src, authToken);

  useEffect(() => {
    const targetElement = target.current;
    if (!targetElement) return undefined;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutationRecord => {
        const observedWidth = parseInt(mutationRecord.target.style.width, 10);
        const observedHeight = parseInt(mutationRecord.target.style.height, 10);

        setLineSize(previousSize => {
          const height = observedHeight || previousSize.height;
          const width = observedWidth ? Math.max(observedWidth - 20, 0) : previousSize.width;

          if (svgLineRef.current) {
            svgLineRef.current.setAttribute('width', `${width}px`);
            svgLineRef.current.viewBox.baseVal.width = width;
          }

          if (width === previousSize.width && height === previousSize.height) return previousSize;
          return { width, height };
        });
      });
    });

    observer.observe(targetElement, { attributes: true, attributeFilter: ['style'] });
    return () => observer.disconnect();
  }, [props.entityId]);

  return (
    <div
      ref={target}
      data-lock={entity.lock}
      id={`_${props.entityId}_`}
      data-type={props.dataType}
      data-page={props.pageId}
      className={props.className}
      data-target={props.dataTarget}
      style={entity.style.master}
      onMouseDown={props.onMouseDown}
      onMouseOver={props.onMouseOver}
    >
      <div>
        {!template && (
          <ReactSVG
            src={src}
            afterInjection={(error, svg) => {
              if (error) {
                return;
              }
              if (!template && !_.get(entity, 'data.width')) {
                svgLineRef.current = svg;
                lineConfig.color = svg.getAttribute('fill');
                lineConfig.width = parseFloat(svg.getAttribute('width'));
                const startMarker = svg.querySelector('#start');
                if (startMarker) {
                  lineConfig.start = {};
                  lineConfig.start.width = startMarker.getAttribute('markerWidth');
                  lineConfig.start.height = startMarker.getAttribute('markerHeight');
                  lineConfig.start.path = startMarker.querySelector('path').getAttribute('d');
                }
                const endMarker = svg.querySelector('#end');
                if (endMarker) {
                  lineConfig.end = {};
                  lineConfig.end.width = endMarker.getAttribute('markerWidth');
                  lineConfig.end.height = endMarker.getAttribute('markerHeight');
                  lineConfig.end.path = endMarker.querySelector('path').getAttribute('d');
                }
                const stroke = svg.querySelector('#stroke');
                lineConfig.dasharray = stroke.getAttribute('stroke-dasharray');
                lineConfig.linecap = stroke.getAttribute('stroke-linecap');
                lineConfig.thickness = stroke.getAttribute('stroke-width');

                if (!_.get(entity, 'data.width')) {
                  dispatch(
                    designActions.changeEntityData(
                      currentPage,
                      props.entityId,
                      lineConfig,
                      'noCache',
                    ),
                  );
                }
              }
              setTemplate(1);
            }}
            beforeInjection={svg => {
              // svg.classList.add('svg-class-name');
              // svg.setAttribute(
              //   'style',
              //   `width: ${_.get(entity, 'style.inner.width')}; height: ${_.get(
              //     entity,
              //     'style.inner.height',
              //   )};`,
              // );
            }}
            evalScripts="always"
            fallback={() => <span style={{ color: 'red' }}>Error: Can not load line</span>}
            loading={
              () => (
                <span style={{ width: _.get(lineSize, 'width'), display: 'block' }}>
                  'L O A D I N G'
                </span>
              )
              // <img
              //   style={{ width: _.get(lineSize, 'width'), height: _.get(lineSize, 'height') }}
              //   src={require('../../assets/images/lineLoading.svg')}
              // />
            }
            renumerateIRIElements={false}
            wrapper="span"
            className="swrapper"
          />
        )}
        {template === 1 && (
          <svg width={`${lineSize.width}px`} height="10px" viewBox={`0 -5 ${lineSize.width} 10`}>
            <defs>
              {lineConfig.start && lineConfig.start.path && (
                <marker
                  id={`lMs${props.entityId}`}
                  refX={lineConfig.start.width / 2}
                  refY={lineConfig.start.height / 2}
                  markerWidth={lineConfig.start.width}
                  markerHeight={lineConfig.start.height}
                  orient="auto"
                >
                  <path d={lineConfig.start.path} stroke="none" fill={lineConfig.color} />
                </marker>
              )}
              {lineConfig.end && lineConfig.end.path && (
                <marker
                  id={`lMe${props.entityId}`}
                  refX={lineConfig.end.width / 2}
                  refY={lineConfig.end.height / 2}
                  markerWidth={lineConfig.end.width}
                  markerHeight={lineConfig.end.height}
                  orient="auto"
                >
                  <path d={lineConfig.end.path} stroke="none" fill={lineConfig.color} />
                </marker>
              )}
            </defs>
            <path
              d={`M 0,0 Q 0,0 ${lineSize.width},0`}
              stroke={lineConfig.color}
              strokeWidth={lineConfig.thickness}
              fill="none"
              markerStart={`url(#lMs${props.entityId})`}
              markerEnd={`url(#lMe${props.entityId})`}
              strokeDasharray={lineConfig.dasharray}
              strokeLinecap={lineConfig.linecap}
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default VLine;

//** Line Config Sample **************************
// color: '#005e60',
//   dasharray: '0 7',
//   linecap: 'round',
//   thickness: 5,
//   start: {
//     path: 'M0,0 L0,5 L5,5 L5,0 L0,0',
//     width: 5,
//     height: 5,
//   },
//   end: {
//     path: 'M0,0 L0,5 L5,2.5 L0,0',
//     width: 5,
//     height: 5,
//   },
// };
